export enum PrivacyStatus {
	All = 'ALL',
	SelectedUsers = 'SELECTED_USERS',
	SelectedUsersStaff = 'SELECTED_USERS_STAFF',
	OrganisationTeams = 'ORGANISATION_TEAMS',
	OrganisationAllEmployees = 'ORGANISATION_ALL_EMPLOYEES',
	None = 'NONE',
}
